import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installAuthFetch } from './services/authFetchPatch';

// То же самое для голого fetch (страница провайдеров и соседи ходят им, а роутер
// /api_providers/* закрыт verify_admin с 10.09.2026).
installAuthFetch();

// Глобально подставляем admin-JWT во ВСЕ axios-запросы (если компонент не задал свой
// заголовок). Нужно, т.к. часть админ-эндпоинтов теперь под verify_admin (cost-reference и др.),
// а многие вызовы идут через голый axios без ручного Authorization.
axios.interceptors.request.use((config) => {
  const t = localStorage.getItem('authToken');
  if (t) {
    config.headers = config.headers || {};
    if (!(config.headers as any).Authorization) {
      (config.headers as any).Authorization = `Bearer ${t}`;
    }
  }
  return config;
});

// 🔴 Прежний инлайн-патч fetch снят 10.09.2026: он считал своим ЛЮБОЙ путь, начинающийся
// со слэша, включая protocol-relative `//чужой-хост/x` — админ-токен уезжал наружу. Замена —
// `installAuthFetch()` выше: разбирает адрес и сравнивает origin.

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();